export default "__VITE_ASSET__a3884078__"